export const downloadHandler = async (url: string, filename: string) => {
    try {
        // Fetch the file from the URL
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        // Convert the response to a Blob
        const blob = await response.blob();

        // Create a temporary URL for the Blob
        const objectUrl = URL.createObjectURL(blob);

        // Create an anchor element for triggering the download
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = filename; // Use the provided filename for the download
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up by revoking the Object URL and removing the link element
        URL.revokeObjectURL(objectUrl);
        document.body.removeChild(link);
    } catch (error) {
        console.error("Error downloading the file:", error);
    }
};

export const getFilenameFromLink = (fileLink: string) => {
    const fullFileName = fileLink.substring(fileLink.lastIndexOf('/') + 1);
    return fullFileName.substring(0, fullFileName.lastIndexOf('.'));
};